import React from 'react';
import * as msgpub from "msgpub";
import { TokenInput, Heading, ButtonG } from '../Common';
import { connecting, disconnecting, DisablesContext, SetDisablesContext, beforeConnecting, onClick } from "../../constant/UserMqtt";
import { Box, Grid, CheckBox, TextInput } from 'grommet';
import { HeaderStyleForGrommet, MainStyleForGrommet } from '../../constant/Styles';
import { removeNonNumericChar, blurActiveElement, USER_OPTION } from '../../common/common';


export default function InputFormComponent(props: {
    user?: msgpub.User, token: string,
    setToken: any, setLog: any,
    setUser: any, setAus: any, setActiveIndice: any
}) {
    const { user, token, setToken, setLog, setUser, setAus, setActiveIndice } = props;

    const [timeout, setTimeout] = React.useState("");
    const [keep, setKeep] = React.useState(false);
    const [checked, setChecked] = React.useState(false);
    const disables = React.useContext(DisablesContext);
    const setDisables = React.useContext(SetDisablesContext);
    const [appName, setAppName] = React.useState("");
    const [userName, setUserName] = React.useState("");
    const [sessionName, setSessionName] = React.useState("");
    const [isClicked, setIsClicked] = React.useState(false); // 接続ボタンが押されたかどうか

    React.useEffect(() => {
        if (user !== undefined && appName !== "" && userName !== "" && token !== "" && isClicked) {
            user.setConnectCallback((sessionPresent: boolean) => {
                setLog((prevLog: string) => (prevLog + "sessionPresent: " + sessionPresent + "\n"
                    + "previous session = " + sessionPresent + "\n"));
                setDisables(connecting);
                setAus("app: " + appName + ", user: " + userName + ", session: " + sessionName);
                setActiveIndice([1, 2, 3]);
            });
            user?.setErrorCallback((e: Error) => {
                setLog((prevLog: string) => (prevLog + e.message + '\n'));
                setDisables(beforeConnecting);
                setIsClicked(false);
                setAus();
                setActiveIndice([0]);
            });
            user?.setCloseCallback(() => {
                setLog((prevLog: string) => (prevLog + 'closed.\n'));
                setDisables(beforeConnecting);
                setIsClicked(false);
                setAus();
                setActiveIndice([0]);
            });
            const option = USER_OPTION;
            let connectTimeout = timeout === "" ? 30 : Number(timeout);
            connectTimeout = connectTimeout*1000;
            const options = {...option, token: token, connectTimeout: connectTimeout};
            user?.setKeep(keep);
                user?.connect(options);
                setDisables(onClick);
                blurActiveElement();
            }
    }, [appName, userName, sessionName, setAus, setDisables, setLog, token, user, isClicked, setIsClicked, setActiveIndice]);

    const connect = () => {
        const tokenName = token;
        let options = {
            app: appName,
            user: userName,
	        session: sessionName
        };
        setUser(new msgpub.User(options));
        setIsClicked(true);
    };

    const reload = () => {
        window.location.reload();
    };

    const disconnect = () => {
        user?.setCloseCallback(() => {
            setLog((prevLog: string) => (prevLog + "disconnected.\n"));
            setDisables(disconnecting);
            setIsClicked(false);
            setAus();
            setActiveIndice([0]);
        });

        if (disables !== onClick) {
            user?.close();
        } else {
            user?.forceClose();
        }

        blurActiveElement();
    }

    const onChangeForAppName = (event: React.ChangeEvent<HTMLInputElement>) => {
        setAppName(event.target.value);
    }

    const onChangeForUserName = (event: React.ChangeEvent<HTMLInputElement>) => {
        setUserName(event.target.value);
    }

    const onChangeForSessionName = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSessionName(event.target.value);
    }

    const onChangeForTimeout = (event: React.ChangeEvent<HTMLInputElement>) => {
        removeNonNumericChar(event.target.value, setTimeout);
    }

    const onChangeForToken = (event: React.ChangeEvent<HTMLInputElement>) => {
        setToken(event.target.value);
    }

    const onChangeForCheckBox = (event: React.ChangeEvent<HTMLInputElement>) => {
        setChecked(!checked);
        setKeep((prevKeep: boolean) => { return !prevKeep });
    }

    return (
        <div>
            <Grid
                rows={['auto', 'auto']}
                columns={['auto', 'auto']}
                gap="xsmall"
                areas={[
                    { name: 'header', start: [0, 0], end: [1, 0] },
                    { name: 'main', start: [0, 1], end: [1, 1] },
                ]}
            >
                <Box {...HeaderStyleForGrommet}>
                    <Heading title={"connect"} />
                </Box>
                <Box {...MainStyleForGrommet}>
                    <form>
                        <TextInput placeholder="app" size="small" value={appName} onChange={onChangeForAppName} disabled={disables.app} />
                        <TextInput placeholder="user" size="small" value={userName} onChange={onChangeForUserName} disabled={disables.user} />
                        <TextInput placeholder="session" size="small" value={sessionName} onChange={onChangeForSessionName} disabled={disables.session} />
                        <TextInput placeholder="timeout:(default 30s)" size="small" value={timeout} onChange={onChangeForTimeout} disabled={disables.timeout} />
                        <TokenInput placeholder="token" value={token} onChange={onChangeForToken} disabled={disables.token} />
                        <CheckBox label={"keep"} checked={checked} onChange={onChangeForCheckBox} disabled={disables.keep} />
                        <ButtonG name="connect" callback={connect} disabled={disables.connect} />
                        <ButtonG name="disconnect" callback={disconnect} disabled={disables.disconnect} />
                        <ButtonG name="switch user" callback={reload} disabled={disables.userSwitching} />
                    </form>
                </Box>
            </Grid>
        </div>
    );
}
